import passengerSSRDimensionsInterface from '../../interfaces/client/PassengerSSRDimensions'
import PassengerSSROptionsInterface from '../../interfaces/client/PassengerSSROptions'

export const ADD_PASSENGER_SSR = 'ADD_PASSENGER_SSR'

export default (
  passengerId: string,
  passengerSSRId: string,
  ssrId: string,
  options: PassengerSSROptionsInterface,
  dimensions?: passengerSSRDimensionsInterface
) => ({
  type: ADD_PASSENGER_SSR,
  passengerId,
  passengerSSRId,
  ssrId,
  options,
  dimensions,
})
